import React, { useState } from 'react';
import { Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core';
import PaletteIcon from '@material-ui/icons/Palette';
import { ColorPaletteDisplay } from './colorHelper';

const PalettePicker = ({ palettes, selectedPaletteId, onPaletteChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  function openPaletteMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function closePaletteMenu() {
    setAnchorEl(null);
  }

  function handleChangeColorPalette(palette) {
    onPaletteChange(palette.id);
    closePaletteMenu();
  }

  return (
    <>
      <Tooltip title='Color Palette' placement='bottom'>
        <IconButton
          onClick={openPaletteMenu}
          style={{ padding: 4, marginLeft: 2 }}
        >
          <PaletteIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id='quick-filters'
        anchorEl={anchorEl}
        transformOrigin={{
          vertical: -32,
          horizontal: 'left',
        }}
        open={Boolean(anchorEl)}
        keepMounted
        onClose={closePaletteMenu}
      >
        {palettes.map((palette) => {
          return (
            <MenuItem
              key={palette.id}
              selected={palette.id === selectedPaletteId}
              onClick={() => handleChangeColorPalette(palette)}
            >
              <ColorPaletteDisplay palette={palette} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default PalettePicker;
